/**
 *
 * @description QuantityBox.tsx
 * @author yikkok <yikok.yong@gmail.com>
 * @version 1.0.0
 * @since 12 November 2021
 *
 */

import { MinusIcon, PlusIcon } from '@heroicons/react/outline';
import { useState } from 'react';

type Props = {
  init?: number | undefined;
  onDecrease: (value: number) => void;
  onIncrease: (value: number) => void;
};
export default function QuantityBox({ init = 1, onIncrease, onDecrease }: Props) {
  const [qty, setQty] = useState(init);

  const add = () => {
    setQty((prev) => {
      const newValue = prev + 1;

      onIncrease(newValue);

      return newValue;
    });
  };

  const minus = () => {
    setQty((prev) => {
      const newValue = prev - 1;

      if (newValue === 0) {
        onDecrease(0);
        return 0;
      }

      onDecrease(newValue);

      return newValue;
    });
  };

  return (
    <div className='flex items-center justify-center'>
      <div className='bg-main-300 p-2 rounded-md cursor-pointer' onClick={minus}>
        <MinusIcon className='h-4 w-4' />
      </div>
      <div className='px-4'>{qty}</div>
      <div className='bg-main-300 p-2 rounded-md cursor-pointer' onClick={add}>
        <PlusIcon className='h-4 w-4' />
      </div>
    </div>
  );
}
